// extracted by mini-css-extract-plugin
export default {"search":"CLB3SIaK"};